/**
 * @Description 益禾堂营业额系统预估2
 * https://confluence.lanhanba.com/pages/viewpage.action?pageId=132274569
 */

import { FC } from 'react';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';

interface EstimateSalesTwoProps {
  propertyItem: any;
  required: boolean;
}
const EstimateSalesTwo:FC<EstimateSalesTwoProps> = ({
  propertyItem,
  required
}) => {

  return (
    <V2FormInputNumber
      label={propertyItem?.anotherName || propertyItem?.name}
      name={propertyItem?.identification}
      placeholder='选择详细地址后自动获取'
      required={required}
      disabled={true}
      config={{
        addonAfter: '元'
      }}
    />
  );
};

export default EstimateSalesTwo;
